import styles from './HorizontalNavbar.module.css';

const HorizontalNavbar = (props) => {
    const menuItems = props?.menuItems;
    const activeKey = props?.activeKey;
    const setActiveKey = props?.setActiveKey;

    return (
        <nav className={styles.menuContainer}>
        <ul className={styles.menuList}>
            {menuItems?.map((item) => {
            const isActive = activeKey === item.key;
            
            return (
                <li
                key={item.key}
                className={`${styles.menuItem} ${isActive ? styles.active : ''}`}
                onClick={() => setActiveKey(item.key)}
                >
                <span className={styles.label}>{item.label}</span>
                <div className={styles.underline} />
                </li>
            );
            })}
        </ul>
        </nav>
    );
};

export default HorizontalNavbar;